import { useTranslation } from '@frontend/i18n';
import { PanelPortal, PanelHeader, PanelContent } from '@frontend/panel-engine';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { TaskList, TaskModeRenderer } from './components';
import { TASK_CENTER_CONSTANTS } from './constants';
import { taskCenterTrackingIds } from './tracking-ids';

export const TaskCenterPanel = () => {
  const { t } = useTranslation('task-center');
  const { isTaskCenterOpen, setIsTaskCenterOpen } = useTaskCenterStore(['isTaskCenterOpen', 'setIsTaskCenterOpen']);

  const onClose = () => {
    setIsTaskCenterOpen(false);
  };

  if (isTaskCenterOpen) {
    return (
      <PanelPortal enableAnimations id='task-center' width={TASK_CENTER_CONSTANTS.PANEL_WIDTH} onClose={onClose}>
        <PanelHeader.Close
          iconName='x'
          size='large'
          style={{ alignSelf: 'flex-end' }}
          trackingId={taskCenterTrackingIds.panelHeaderCloseButton}
          label={t('Close')}
        />
        <PanelContent padding={false} css={{ display: 'flex' }}>
          <TaskList />
          <TaskModeRenderer />
        </PanelContent>
      </PanelPortal>
    );
  }
  return null;
};
